import { UIEventHandler, useState } from 'react';

interface Props {
    totalCount: number;
    padding?: number;
}
function useScrollIndicator({ totalCount, padding }:Props) {
    const [current, setCurrent] = useState<number>(0);
    const onScroll: UIEventHandler<HTMLDivElement> = (e) => {
        const { scrollLeft, scrollWidth, offsetWidth } = e.currentTarget;
        const percent = scrollLeft / (scrollWidth - offsetWidth + (padding || 0) * 2);
        setCurrent(Math.floor(percent * totalCount));
    };
    return {
        onScroll,
        current,
    };
}

export default useScrollIndicator;
